(() => {
  const variants = window.HERLAYRA_VARIANTS || {};
  const prices = window.HERLAYRA_PRICES || {};
  const sellingPlan = window.HERLAYRA_SELLING_PLAN;
  const productUrl = window.HERLAYRA_PRODUCT_URL || '/products/herlayra-routine-kit';
  const assetBase = window.HERLAYRA_ASSET_BASE || '/cdn/shop/t/1/assets/';
  const enableSub = !!window.HERLAYRA_ENABLE_SUBSCRIPTION;
  const directAtc = window.HERLAYRA_DIRECT_ATC !== false;
  const drawer = document.getElementById('cartDrawer');
  const drawerBody = drawer?.querySelector('[data-drawer-body]') || drawer?.querySelector('.drawer-body');
  const closeBtn = document.querySelector('[data-drawer-close]');
  const opts = [...document.querySelectorAll('.opt')];
  const submodes = [...document.querySelectorAll('.submode')];
  const ctaMain = document.getElementById('ctaMain');
  const stickyCta = document.getElementById('stickyCta');
  const stickyLbl = document.getElementById('stickyLbl');
  const stickyChange = document.getElementById('stickyChange');
  const form = document.getElementById('HerlayraProductForm');
  const formVariant = document.getElementById('HerlayraVariantId');
  const formPlan = document.getElementById('HerlayraSellingPlan');
  const consent = document.getElementById('HerlayraSubConsent');
  const status = document.getElementById('HerlayraSelectionStatus');
  const drawerStatus = document.getElementById('HerlayraDrawerStatus');
  // dialog showModal() làm phần ngoài inert → SR cần aria-live NẰM TRONG dialog; ghi cả hai
  function announce(msg){ if(status) status.textContent = msg; if(drawerStatus) drawerStatus.textContent = msg; }
  let selected = document.querySelector('.opt[data-key="core"]');
  let lastInvoker = null;
  const names = { [variants.essential]:'Essential', [variants.core]:'Core Routine', [variants.complete]:'Complete Routine' };
  const contents = { [variants.essential]:'1 Scalp Serum (79 ml) — just the scalp step.', [variants.core]:'2 Scalp Serums + mini Shampoo & Conditioner (45 ml trial sizes).', [variants.complete]:'2 Scalp Serums + full-size Shampoo & Conditioner (237 ml each).' };
  const thumbs = { [variants.essential]:'tile-essential-1x1.jpg', [variants.core]:'tile-core-1x1.jpg', [variants.complete]:'tile-complete-1x1.jpg' };
  const thumbWebp = file => file.replace(/\.(jpe?g|png)$/i, '.webp');

  function initGallery(){
    const main = document.querySelector('.main-img img');
    const thumbs = [...document.querySelectorAll('.thumb-media')];
    if(!main || !thumbs.length) return;
    function activate(thumb){
      const img = thumb.querySelector('img');
      if(!img) return;
      main.style.opacity = '0';
      window.setTimeout(() => {
        const pic = main.parentNode;
        if(pic && pic.tagName === 'PICTURE'){
          // rebuild <source> theo data-fullwebp của thumb (đừng xoá vĩnh viễn — giữ đường webp của hero sống sau tương tác gallery)
          pic.querySelectorAll('source').forEach(s => s.remove());
          if(img.dataset.fullwebp){
            const s = document.createElement('source');
            s.type = 'image/webp'; s.srcset = img.dataset.fullwebp;
            pic.insertBefore(s, main);
          }
        }
        main.removeAttribute('srcset'); main.removeAttribute('sizes');
        main.src = img.dataset.full || img.src;
        main.alt = img.alt || main.alt;
        main.style.opacity = '1';
      }, 150);
      thumbs.forEach(t => { t.classList.remove('is-active'); t.setAttribute('aria-pressed','false'); });
      thumb.classList.add('is-active'); thumb.setAttribute('aria-pressed','true');
    }
    thumbs.forEach(thumb => {
      thumb.tabIndex = 0; thumb.setAttribute('aria-pressed', thumb.classList.contains('is-active') ? 'true' : 'false');
      thumb.setAttribute('role','button');
      thumb.addEventListener('click', () => activate(thumb));
      thumb.addEventListener('keydown', e => { if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); activate(thumb); } });
    });
    let startX = null;
    main.addEventListener('touchstart', e => { startX = e.touches[0]?.clientX ?? null; }, {passive:true});
    main.addEventListener('touchend', e => {
      if(startX == null) return;
      const dx = (e.changedTouches[0]?.clientX ?? startX) - startX;
      if(Math.abs(dx) < 30) return;
      const idx = Math.max(0, thumbs.findIndex(t => t.classList.contains('is-active')));
      activate(thumbs[(idx + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length]);
      startX = null;
    }, {passive:true});
  }

  function selectedMode(){ return document.querySelector('.submode[aria-checked="true"]')?.dataset.mode || 'once'; }
  function usingPlan(){ return selected?.dataset.key === 'complete' && enableSub && selectedMode() === 'sub'; }
  function money(cents){ return '$' + (Number(cents || 0) / 100).toFixed(2); }
  function label(){ if(!selected) return 'Start With Core — $69'; if(usingPlan()) return 'Subscribe — $79 every 60 days'; return selected.dataset.name + ' — ' + (prices[selected.dataset.key] || selected.dataset.price); }
  const buy = document.getElementById('buy');
  const sticky = document.getElementById('sticky');
  const isPdpSticky = !!(buy && ctaMain && sticky && stickyCta);
  const stickyQuery = new URLSearchParams(location.search);
  let seenBuy = stickyQuery.has('tier') || stickyQuery.has('variant');
  function stickyEvent(action){ window.dispatchEvent(new CustomEvent('herlayra:sticky_cta',{detail:{action,tier:selected?.dataset.key || 'core'}})); }
  function scrollToBuy(action){
    stickyEvent(action);
    buy?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
    window.setTimeout(() => document.querySelector('.opt[aria-checked="true"]')?.focus({preventScroll:true}), 450);
  }
  function renderSticky(){
    if(!isPdpSticky) return;
    if(!seenBuy){
      stickyCta.textContent = 'See routines & prices ↓';
      stickyCta.classList.add('is-pre');
      if(stickyLbl) stickyLbl.textContent = 'Essential $39 · Core $69 · Complete $99';
      if(stickyChange) stickyChange.hidden = true;
      return;
    }
    stickyCta.classList.remove('is-pre');
    stickyCta.textContent = label();
    if(stickyLbl) stickyLbl.textContent = selected?.dataset.lbl || label();
    if(stickyChange) stickyChange.hidden = false;
  }
  function sync(){
    if(!selected) return;
    const key = selected.dataset.key;
    const usePlan = usingPlan();
    document.querySelector('.subtoggle')?.classList.toggle('is-active', key === 'complete');
    if(ctaMain) ctaMain.textContent = label();
    renderSticky();
    if(status) status.textContent = label();
    if(formVariant) formVariant.value = variants[key] || '';
    if(formPlan){ formPlan.disabled = !usePlan; formPlan.value = usePlan ? sellingPlan : ''; }
    document.querySelectorAll('.rosca-line,.rosca-consent').forEach(el => { el.hidden = !usePlan; });
    document.querySelector('.dynamic-checkout')?.toggleAttribute('hidden', usePlan);
    document.body.classList.toggle('sub-off', !enableSub);
  }
  function selectOpt(o){ selected = o; opts.forEach(x => { x.setAttribute('aria-checked','false'); x.tabIndex = -1; }); o.setAttribute('aria-checked','true'); o.tabIndex = 0; sync(); }
  async function getCart(){ const res = await fetch('/cart.js', {headers:{'Accept':'application/json'}}); if(!res.ok) throw new Error('cart fetch failed'); return res.json(); }
  async function setRoute(route){ if(!route) return; const cart = await getCart().catch(() => null); if(cart?.attributes?.route) return; await fetch('/cart/update.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({attributes:{route}})}); }
  function lineName(item){ return item.selling_plan_allocation ? 'Complete Routine — Subscribe & Save' : names[String(item.variant_id)] || ('HERLAYRA Routine Kit — ' + (item.variant_title || '')); }
  function closeDrawer(){ if(drawer?.close) drawer.close(); else drawer?.removeAttribute('open'); lastInvoker?.focus?.(); }

  function renderCart(cart){
    if(!drawerBody) return;
    if(!cart.items?.length){
      sessionStorage.removeItem('hly-fs-nudge');
      sessionStorage.removeItem('hly-cu-nudge');
      drawerBody.innerHTML = '<p>Your cart is empty — no rush. The scalp step will be here when you\'re ready.</p><a class="fallback" href="' + productUrl + '">Shop the routine</a>';
      return;
    }
    const shipping = cart.total_price >= 4000 ? 'Free US shipping — included.' : 'US shipping: flat $5 — no surprises at checkout.';
    const lines = cart.items.map((item, idx) => {
      const id = String(item.variant_id);
      const meta = item.selling_plan_allocation ? '<p class="drawer-meta">' + money(item.selling_plan_allocation.price) + ' every 60 days (save $20). Auto-renews every 60 days until cancelled. Cancel anytime — <a href="/pages/subscription-terms" class="nowrap">Subscription Terms →</a></p>' : '';
      const thumb = thumbs[id] || 'thumb-serum-240.jpg';
      const source = thumbs[id] ? '<source srcset="' + assetBase + thumbWebp(thumb) + '" type="image/webp">' : '';
      const name = lineName(item);
      const n = idx + 1;
      const qtyRow = '<div class="drawer-qty"><button type="button" data-qty-dec aria-label="Decrease quantity, ' + name + '">−</button><label class="visually-hidden" for="DrawerQty-' + n + '">Quantity, ' + name + '</label><input id="DrawerQty-' + n + '" type="number" min="0" inputmode="numeric" value="' + item.quantity + '" data-qty-input><button type="button" data-qty-inc aria-label="Increase quantity, ' + name + '">+</button><button type="button" class="drawer-remove" data-line-remove aria-label="Remove ' + name + ' from cart">Remove</button></div>';
      return '<div class="drawer-line" data-line="' + n + '"><picture>' + source + '<img src="' + assetBase + thumb + '" alt="' + name + '" width="56" height="56"></picture><div><strong>' + name + '</strong><span>' + (contents[id] || '') + '</span>' + meta + '<b>' + money(item.final_line_price) + '</b></div>' + qtyRow + '</div>';
    }).join('');
    const nudge = cart.total_price < 4000 && sessionStorage.getItem('hly-fs-nudge') !== 'dismissed' ? '<div class="drawer-nudge" role="note" aria-label="Shipping options"><b>About shipping</b><p>Essential ships flat $5 — $44 all-in, no surprises. Core and Complete ship free. Keep Essential if the serum is all you want, or switch to Core ($69, ships free) if you wanted the fuller routine anyway.</p><button type="button" data-drawer-switch>Switch to Core — $69</button><button type="button" data-drawer-dismiss>Keep Essential — $5 is fine</button></div>' : '';
    const item0 = cart.items[0];
    const soloCore = cart.items.length === 1 && String(item0.variant_id) === String(variants.core) && item0.quantity === 1 && !item0.selling_plan_allocation;
    const upNudge = soloCore && sessionStorage.getItem('hly-cu-nudge') !== 'dismissed' ? '<div class="drawer-nudge" role="note" aria-label="Upgrade option"><b>Make it the full routine?</b><p>Complete swaps your trial-size minis for full-size Shampoo & Conditioner (237 ml each instead of 45 ml — about 5× more of the wash step, $30 more). Same serums, same guarantee.</p><button type="button" data-drawer-upgrade>Upgrade to Complete — $99</button><button type="button" data-drawer-upgrade-dismiss>Keep Core — $69 is plenty</button></div>' : '';
    drawerBody.innerHTML = lines + '<p class="drawer-ship">' + shipping + '</p>' + nudge + upNudge + '<div class="drawer-subtotal"><span>Subtotal</span><b>' + money(cart.total_price) + '</b></div><a class="checkout" href="/checkout" data-drawer-checkout>Checkout</a><p class="drawer-ship" style="margin-top:6px">Secure checkout — cards, Shop Pay, Apple Pay & Google Pay.</p><p class="drawer-links"><a href="/cart">Review your cart →</a> <button type="button" data-drawer-close-inline>Keep browsing</button></p><p class="drawer-disclosure">90-Day Love-It Guarantee (first one-time order) · 30-day returns · Real humans answer: contact@herlayra.com — <a href="/pages/guarantee-terms">Guarantee terms →</a></p><p class="drawer-error" role="alert">We couldn\'t add this automatically — nothing was charged. Please try again, or finish on the product page.</p>';
    drawerBody.querySelector('[data-drawer-dismiss]')?.addEventListener('click', e => { window.dispatchEvent(new CustomEvent('herlayra:cart_nudge', {detail:{action:'keep_essential'}})); sessionStorage.setItem('hly-fs-nudge','dismissed'); e.currentTarget.closest('.drawer-nudge')?.remove(); });
    drawerBody.querySelector('[data-drawer-switch]')?.addEventListener('click', async () => {
      window.dispatchEvent(new CustomEvent('herlayra:cart_nudge', {detail:{action:'switch_to_core'}}));
      const cart = await getCart().catch(() => null);
      const updates = {};
      if (variants.essential) updates[variants.essential] = 0;
      const currentCore = cart?.items?.find(i => String(i.variant_id) === String(variants.core))?.quantity || 0;
      if (variants.core) updates[variants.core] = currentCore + 1;
      fetch('/cart/update.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates})}).then(getCart).then(renderCart);
    });
    drawerBody.querySelector('[data-drawer-upgrade-dismiss]')?.addEventListener('click', e => { window.dispatchEvent(new CustomEvent('herlayra:cart_nudge', {detail:{action:'keep_core'}})); sessionStorage.setItem('hly-cu-nudge','dismissed'); e.currentTarget.closest('.drawer-nudge')?.remove(); });
    drawerBody.querySelector('[data-drawer-upgrade]')?.addEventListener('click', async e => {
      const btn = e.currentTarget;
      btn.disabled = true;
      window.dispatchEvent(new CustomEvent('herlayra:cart_nudge', {detail:{action:'upgrade_to_complete'}}));
      try{
        const current = await getCart();
        const updates = {};
        if(variants.core) updates[variants.core] = 0;
        const existing = current.items?.find(i => String(i.variant_id) === String(variants.complete) && !i.selling_plan_allocation)?.quantity || 0;
        if(variants.complete) updates[variants.complete] = existing + 1;
        const res = await fetch('/cart/update.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates})});
        if(!res.ok) throw new Error('cart update failed');
        const updated = await res.json();
        const title = document.getElementById('cartDrawerTitle');
        if(title) title.textContent = 'Your cart';
        renderCart(updated);
        restoreDrawerFocus();
      }catch(err){
        btn.disabled = false;
        const errEl = drawerBody?.querySelector('.drawer-error');
        if(errEl){ errEl.textContent = 'We couldn\'t update your cart just now — your items are unchanged. Please try again.'; errEl.style.display = 'block'; }
        announce('Cart update failed. Please try again.');
      }
    });
    drawerBody.querySelector('[data-drawer-close-inline]')?.addEventListener('click', closeDrawer);
    announce('Cart updated. Subtotal '+money(cart.total_price)+'.');
    drawerBody.querySelector('[data-drawer-checkout]')?.addEventListener('click', () => window.dispatchEvent(new CustomEvent('herlayra:begin_checkout', {detail:{surface:'drawer',value:cart.total_price,items:cart.items.map(i=>({key:String(i.variant_id),quantity:i.quantity,selling_plan:i.selling_plan_allocation?.selling_plan?.id || null}))}})));
  }

  function restoreDrawerFocus(hint){
    const target = (hint && drawerBody?.querySelector(hint)) || drawerBody?.querySelector('[data-drawer-checkout]') || drawerBody?.querySelector('.fallback') || closeBtn;
    target?.focus?.();
  }
  function setLineBusy(lineEl, busy){ lineEl.querySelectorAll('[data-qty-dec],[data-qty-inc],[data-qty-input],[data-line-remove]').forEach(el => { el.disabled = busy; }); }
  async function changeLine(lineEl, quantity, focusHint){
    if(!lineEl) return;
    setLineBusy(lineEl, true);
    try{
      const res = await fetch('/cart/change.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:Number(lineEl.dataset.line),quantity:quantity})});
      if(!res.ok) throw new Error('cart change failed');
      const cart = await res.json();
      const title = document.getElementById('cartDrawerTitle');
      if(title) title.textContent = 'Your cart';
      renderCart(cart);
      restoreDrawerFocus(focusHint);
    }catch(err){
      const cart = await getCart().catch(() => null);
      if(cart) renderCart(cart); else setLineBusy(lineEl, false);
      const errEl = drawerBody?.querySelector('.drawer-error');
      if(errEl){ errEl.textContent = 'We couldn\'t update your cart just now — your items are unchanged. Please try again.'; errEl.style.display = 'block'; }
      announce('Cart update failed. Please try again.');
      if(cart) restoreDrawerFocus(focusHint);
    }
  }
  async function openDrawer(key, error, button){
    if(!drawer){ window.location.href = productUrl + '#buy'; return; }
    lastInvoker = button || document.activeElement;
    const title = document.getElementById('cartDrawerTitle');
    if(title) title.textContent = error ? 'Could not add to cart' : 'Added to cart';
    drawer.classList.toggle('error', !!error);
    if(error && drawerBody) drawerBody.innerHTML = '<p class="drawer-error" role="alert">We couldn\'t add this automatically — nothing was charged. Please try again, or finish on the product page.</p><a class="fallback" href="' + productUrl + '#buy">Finish on the product page →</a>';
    if(!error) await getCart().then(renderCart).catch(() => {});
    if(drawer.showModal) drawer.showModal(); else drawer.setAttribute('open','');
    const focusTarget = error ? (drawerBody?.querySelector('.fallback') || closeBtn) : (drawerBody?.querySelector('[data-drawer-checkout]') || drawerBody?.querySelector('.checkout') || closeBtn);
    focusTarget?.focus?.();
  }
  async function addToCart(key, button){
    const id = variants[key];
    const usePlan = key === 'complete' && enableSub && selectedMode() === 'sub';
    if(usePlan && consent && !consent.checked){ consent.focus(); return; }
    try{
      if(!id) throw new Error('missing variant');
      const payload = {id:Number(id),quantity:1};
      if(usePlan) payload.selling_plan = Number(sellingPlan);
      let res = await fetch('/cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
      if(!res.ok){
        await new Promise(r => setTimeout(r, 1200));
        res = await fetch('/cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
      }
      if(!res.ok) throw new Error('cart add failed');
      await setRoute(button?.dataset?.route);
      window.dispatchEvent(new CustomEvent('herlayra:add_to_cart', {detail:{key,id,selling_plan:usePlan?sellingPlan:null}}));
      await openDrawer(key, false, button);
    }catch(err){ await openDrawer(key, true, button); }
  }

  initGallery();
  if(!enableSub) document.body.classList.add('sub-off');
  opts.forEach((o, i) => {
    o.addEventListener('click', e => { if(e.target.closest('.submode')) return; selectOpt(o); });
    o.addEventListener('keydown', e => {
      if(e.target !== o) return;
      if(e.key === ' ' || e.key === 'Enter'){ e.preventDefault(); o.click(); }
      if(['ArrowDown','ArrowRight','ArrowUp','ArrowLeft'].includes(e.key)){ e.preventDefault(); const dir = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : -1; const next = opts[(i + dir + opts.length) % opts.length]; next.focus(); selectOpt(next); }
    });
  });
  // Deep-link: preselect tier from ?variant=<id> (Shopify-standard) or ?tier=<key>
  (function(){
    const q = new URLSearchParams(location.search);
    const tier = q.get('tier');
    const vid = q.get('variant');
    const key = (tier && variants[tier]) ? tier
      : (vid ? Object.keys(variants).find(k => String(variants[k]) === String(vid)) : null);
    const target = key && document.querySelector('.opt[data-key="' + key + '"]');
    if(target) selectOpt(target);
  })();
  submodes.forEach(m => m.addEventListener('click', e => { e.stopPropagation(); submodes.forEach(x => x.setAttribute('aria-checked','false')); m.setAttribute('aria-checked','true'); const complete = document.querySelector('.opt[data-key="complete"]'); if(complete) selectOpt(complete); }));
  consent?.addEventListener('change', sync);
  form?.addEventListener('submit', e => { if(formPlan && !formPlan.disabled && consent && !consent.checked){ e.preventDefault(); consent.focus(); } });
  closeBtn?.addEventListener('click', closeDrawer);
  drawer?.addEventListener('close', () => lastInvoker?.focus?.());
  const qtyTimers = {};
  drawerBody?.addEventListener('click', e => {
    const stepBtn = e.target.closest('[data-qty-dec],[data-qty-inc]');
    const removeBtn = e.target.closest('[data-line-remove]');
    if(!stepBtn && !removeBtn) return;
    const lineEl = e.target.closest('[data-line]');
    if(!lineEl) return;
    window.clearTimeout(qtyTimers[lineEl.dataset.line]);
    if(removeBtn){ changeLine(lineEl, 0); return; }
    const input = lineEl.querySelector('[data-qty-input]');
    const next = Math.max(0, Number(input?.value || 0) + (stepBtn.hasAttribute('data-qty-inc') ? 1 : -1));
    if(input) input.value = next;
    const hint = '[data-line="' + lineEl.dataset.line + '"] ' + (stepBtn.hasAttribute('data-qty-inc') ? '[data-qty-inc]' : '[data-qty-dec]');
    qtyTimers[lineEl.dataset.line] = window.setTimeout(() => changeLine(lineEl, next, hint), 200);
  });
  drawerBody?.addEventListener('change', e => {
    if(!e.target.matches || !e.target.matches('[data-qty-input]')) return;
    const lineEl = e.target.closest('[data-line]');
    if(!lineEl) return;
    window.clearTimeout(qtyTimers[lineEl.dataset.line]);
    changeLine(lineEl, Math.max(0, Number(e.target.value || 0)), '[data-line="' + lineEl.dataset.line + '"] [data-qty-input]');
  });
  drawerBody?.addEventListener('keydown', e => {
    if(e.key === 'Enter' && e.target.matches && e.target.matches('[data-qty-input]')){ e.preventDefault(); e.target.dispatchEvent(new Event('change', {bubbles:true})); }
  });
  document.querySelectorAll('[data-cta="direct-atc"], [data-atc]').forEach(link => link.addEventListener('click', e => { if(!directAtc) return; const key = link.dataset.atc; if(!key) return; e.preventDefault(); addToCart(key, link); }));
  ctaMain?.addEventListener('click', e => { e.preventDefault(); addToCart(selected?.dataset.key || 'core', ctaMain); });
  stickyCta?.addEventListener('click', e => {
    if(!isPdpSticky) return;
    e.preventDefault();
    if(!seenBuy){ scrollToBuy('choose_scroll'); return; }
    stickyEvent('atc');
    addToCart(selected?.dataset.key || 'core', stickyCta);
  });
  stickyChange?.addEventListener('click', e => { e.preventDefault(); scrollToBuy('change_scroll'); });
  const trigger = document.querySelector('[data-sticky-trigger]') || buy || document.getElementById('offer');
  let stickyRaf = false;
  const updateSticky = () => {
    if(!isPdpSticky || stickyRaf) return;
    stickyRaf = true;
    requestAnimationFrame(() => {
      stickyRaf = false;
      const r = buy.getBoundingClientRect();
      const active = r.top < window.innerHeight - 140 && r.bottom > 80;
      if(active && !seenBuy){ seenBuy = true; renderSticky(); }
      const show = !active;
      sticky.classList.toggle('show', show);
      if('inert' in sticky) sticky.inert = !show;
      if(show) setStickyHeight();
    });
  };
  function setStickyHeight(){ if(sticky) document.documentElement.style.setProperty('--sticky-h', sticky.offsetHeight + 'px'); }
  if(isPdpSticky){ window.addEventListener('scroll', updateSticky, {passive:true}); updateSticky(); setStickyHeight(); window.addEventListener('resize', setStickyHeight, {passive:true}); }
  else if(sticky && trigger){
    const anchor = document.getElementById('offer');
    window.addEventListener('scroll', () => {
      const past = trigger.getBoundingClientRect().bottom < 0;
      const r = anchor ? anchor.getBoundingClientRect() : null;
      const inView = !!r && r.top < window.innerHeight && r.bottom > 0;
      sticky.classList.toggle('show', past && !inView);
    }, {passive:true});
  }
  if(buy && buy.id === 'buy' && 'IntersectionObserver' in window){
    let fired = false;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if(!fired && e.isIntersecting){
          fired = true;
          window.dispatchEvent(new CustomEvent('herlayra:PDP-arrival', {detail:{target:'#buy'}}));
          io.disconnect();
        }
      });
    }, {threshold:0.2});
    io.observe(buy);
  }
  const topNav = document.querySelector('.nav');
  if(topNav){
    const navStyle = document.createElement('style');
    navStyle.textContent = '.nav{transition:transform .25s ease}.nav.nav-hidden{transform:translateY(-100%)}@media(prefers-reduced-motion:reduce){.nav{transition:none}}';
    document.head.appendChild(navStyle);
    let navLastY = Math.max(0, window.scrollY), navAcc = 0, navRaf = false;
    window.addEventListener('scroll', () => {
      if(navRaf) return;
      navRaf = true;
      requestAnimationFrame(() => {
        navRaf = false;
        const y = Math.max(0, window.scrollY);
        const d = y - navLastY; navLastY = y;
        if(y < 120){ topNav.classList.remove('nav-hidden'); navAcc = 0; return; }
        navAcc = (d > 0) === (navAcc > 0) ? navAcc + d : d;
        if(navAcc > 24) topNav.classList.add('nav-hidden');
        else if(navAcc < -12) topNav.classList.remove('nav-hidden');
      });
    }, {passive:true});
    topNav.addEventListener('focusin', () => topNav.classList.remove('nav-hidden'));
  }
  sync();
})();
